import { PlayIcon } from "@heroicons/react/24/outline"

export default function TaskIcon({
  canCompleteTask,
  onShowTask,
  onCompleteTask,
  onUncompleteTask,
  isStarted = false,
  isComplete = false,
}) {
  function iconAction(e) {
    e.stopPropagation()

    if (!canCompleteTask) {
      onShowTask()
    } else {
      isComplete ? onUncompleteTask() : onCompleteTask()
    }
  }

  if (isStarted && !isComplete) {
    return (
      <div className="cursor-pointer p-2" onClick={iconAction}>
        <PlayIcon className="h-5 w-5" />
      </div>
    )
  }

  return (
    <div className="cursor-pointer p-2" onClick={iconAction}>
      <input
        type="checkbox"
        className="size-4 rounded border-gray-300 text-blue-600 focus:ring-blue-400/50"
        style={{ width: "16px", height: "16px" }}
        checked={isComplete}
        onChange={() => {}}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          iconAction(e)
        }}
      />
    </div>
  )
}
